// Lib
import { createApi } from "@reduxjs/toolkit/query/react";
// Types
import { UrlQueryParams } from "types/common";
import { GetOrdersResponseDto, OrderResponseDto } from "types/orders";
// Helpers
import { ordersUrlBuilder } from "./urlBuilder/orders";
// Utils
import { coreQuery } from "utils/baseQuery";
import { orderMapper, ordersMapper } from "utils/mappers";

export const ordersAPI = createApi({
  reducerPath: "ordersAPI",
  baseQuery: coreQuery(),
  tagTypes: ["orders", "order"],

  endpoints: build => ({
    getOrders: build.query<GetOrdersResponseDto, { query: UrlQueryParams }>({
      query: ({ query }) => {
        return {
          url: ordersUrlBuilder.getOrders({ query }),
          method: "GET",
        };
      },
      transformResponse: (response: GetOrdersResponseDto) =>
        ordersMapper(response),
      providesTags: ["orders"],
    }),
    getOrder: build.query<OrderResponseDto, { id: string }>({
      query: ({ id }) => {
        return {
          url: ordersUrlBuilder.getOrder({ id }),
          method: "GET",
        };
      },
      transformResponse: (response: OrderResponseDto) => orderMapper(response),
      providesTags: ["order"],
    }),
  }),
});

export const { useGetOrdersQuery, useGetOrderQuery } = ordersAPI;
